import { forwardRef } from 'react';
import { BaseButton, type BaseButtonProps } from '@/Components/Common/Buttons/BaseButton';
import { cn } from '@/lib/utils';

const PrimaryButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ className, ...props }, ref) => {
        return (
            <BaseButton
                ref={ref}
                className={cn('bg-primary text-primary-foreground shadow hover:bg-primary/90', className)}
                {...props}
            />
        );
    },
);
PrimaryButton.displayName = 'PrimaryButton';

export { PrimaryButton };
